module.exports = __webpack_public_path__ + "static/img/icon_swipe_01.fac564f.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_swipe_01.png
// module id = dccY
// module chunks = 1